export default __webpack_public_path__ + "static/media/prod-page-eletrica.5e5b683f.jpg";